import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useDestroyAccountPage = (initPage, accountId) => {
  const { page, setPage, mergePage, resetPage } = usePage(`edit_account`, initPage);

  const fetch = () => {
    if (accountId === undefined || accountId === null) {
      return mergePage({
        loaded: true,
        missing_account: true
      });
    }

    return $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}`)
    })
      .then((response) =>
        mergePage({
          loaded: true,
          account: response
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          account: null
        })
      );
  };

  const deleteAccount = () => {
    mergePage({ saving: true });

    return $.ajax({
      url: ApiRoute(`/api/saas_admin/accounts/${accountId}`),
      method: "DELETE"
    })
      .then(() => {
        mergePage({
          saving: false
        });
      })
      .catch(() => {
        mergePage({
          saving: false,
          errors: ["There was an error"]
        });
      });
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  return { ...page, deleteAccount };
};
